import React, { useRef, useState, useCallback } from 'react';
import { PageDefinition } from '@fullstory/proto/fs/api/pages';
import { useRouteToHeatmap } from '../../hooks/useRouteToHeatmap';
import { Flex, Button, Popover } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';
import { SegmentSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';

export interface ExploreMenuProps {
  pageDefinition: PageDefinition;
  segmentSettings?: SegmentSettings;
}
export const ExploreMenu: React.FC<ExploreMenuProps> = ({ pageDefinition, segmentSettings }) => {
  const anchor = useRef<HTMLDivElement | null>(null);
  const [open, setOpen] = useState(false);
  const routeToHeatmap = useRouteToHeatmap();
  const viewHeatmap = useCallback(
    () =>
      routeToHeatmap({
        pageDefId: pageDefinition.id,
        segmentSettings,
      }),
    [pageDefinition, routeToHeatmap, segmentSettings],
  );

  return (
    <Flex data-component="ExploreMenu" ref={anchor} justifyContent="flex-start">
      <Button
        onClick={e => {
          open ? setOpen(false) : setOpen(true);
          e.stopPropagation(); // Prevent click events from bubbling up to parent
        }}
        iconRight="chevron-down"
        size="small"
        variant="outline"
      >
        <FormattedMessage defaultMessage="Explore..." id="VSWauh" description="Explore button" />
      </Button>
      <Popover
        anchor={anchor.current}
        open={open}
        placement="bottom-end"
        offset={8}
        flipY={false}
        portal={false}
        positioningStrategy="fixed"
        variant="bordered"
      >
        <Button
          testId="explore-heatmap"
          onClick={e => {
            viewHeatmap();
            e.stopPropagation(); // Prevent click events from bubbling up to parent
          }}
          variant="minimal"
        >
          <FormattedMessage
            defaultMessage="Explore Heatmap"
            id="QhQ6eb"
            description="Explore Heatmap button"
          />
        </Button>
      </Popover>
    </Flex>
  );
};
